import { invoices } from "../data";
import { brand } from "@/shared/lib/safecheckBrand";

export const adminDashboardSummary = {
  totalInvoices: 22,
  inReview: 3,
  approved: 0,
  admissions: 1487,
  admissionsToday: 12,
};

export const adminKeyIndicators = [
  {
    id: "totalInvoices",
    value: 22,
    icon: "file",
    color: "text-primary",
    bg: "bg-primary-soft",
    footerKey: "cumulative",
    footerColor: "text-muted",
    footerIcon: "minus",
  },
  {
    id: "inReview",
    value: 3,
    icon: "clock",
    color: "text-yellow",
    bg: "bg-yellow-soft",
    footerKey: "toProcess",
    footerColor: "text-pink",
    footerIcon: "hourglass",
  },
  {
    id: "approved",
    value: 0,
    icon: "check",
    color: "text-green",
    bg: "bg-teal-soft",
    footerKey: "validated",
    footerColor: "text-green",
    footerIcon: "trending",
  },
  {
    id: "admissions",
    value: 12,
    icon: "home",
    color: "text-purple",
    bg: "bg-purple-soft",
    footerKey: "today",
    footerColor: "text-muted",
    footerIcon: "activity",
  },
] as const;

export const adminQuickLinks = [
  // Identifiants conservés pour les styles ; destinations du circuit Assurance.
  { id: "invoices", href: "/dashboard/invoices/submit", icon: "file" },
  { id: "admissions", href: "/dashboard/insurers", icon: "home" },
  { id: "users", href: "/dashboard/users", icon: "users" },
  { id: "providers", href: "/dashboard/providers", icon: "provider" },
  { id: "conventions", href: "/dashboard/requests", icon: "conventions" },
  { id: "logs", href: "/dashboard/invoices", icon: "logs" },
] as const;

export const adminInvoiceDistribution = [
  { key: "submitted", value: 19, color: brand.navy },
  { key: "review", value: 3, color: brand.navyLight },
  { key: "approved", value: 0, color: brand.lime },
  { key: "paid", value: 0, color: brand.limeDark },
  { key: "modify", value: 0, color: brand.navyDark },
];

export const adminMonthlyVolume = [
  { month: "Jan", value: 0 },
  { month: "Feb", value: 0 },
  { month: "Mar", value: 0 },
  { month: "Apr", value: 0 },
  { month: "May", value: 0 },
  { month: "Jun", value: 21 },
];

export const adminSystemStats = [
  { id: "hospitals", value: 15, icon: "hospital" },
  { id: "companies", value: 2, icon: "building" },
  { id: "auditors", value: 3, icon: "auditor" },
  { id: "validationRate", value: "0%", icon: "rate" },
] as const;

export type SubmittedInvoice = {
  id: string;
  displayId: number;
  hospital: string;
  company: string;
  amount: number;
  submittedDate: string;
  delayDays: number;
};

export const submittedInvoices: SubmittedInvoice[] = invoices
  .filter((invoice) => invoice.status === "pending")
  .map(({ id, displayId, hospital, company, amount, submittedDate, delayDays }) => ({
    id,
    displayId,
    hospital,
    company,
    amount,
    submittedDate,
    delayDays,
  }));
